import Swiper, { Navigation, Pagination, EffectFade, EffectCreative } from 'swiper';

import '../../../node_modules/swiper/swiper.css';
import '../../../node_modules/swiper/modules/effect-fade/effect-fade.min.css';

const init = () => {

    const swiper_info = new Swiper('.block-info__slider', {
        modules: [Navigation, Pagination, EffectCreative],
        speed: 800,
        effect: 'creative',
        autoHeight: true,
        creativeEffect: {
            prev: {
                translate: ["-120%", 0, -500],
            },
            next: {
                translate: ["120%", 0, -500],
            },
        },
        //direction: 'vertical',
        loop: true,
        slidesPerView: 1,
        pagination: {
            el: '.block-info__slider-pagination',
            type: 'custom',
            renderCustom: function (swiper, current, total) {
                return current + ' di ' + total;
            }/*
            formatFractionCurrent: function (number) {
                return number < 10 ? '0' + number : number;
            },
            formatFractionTotal: function (number) {
                return number < 10 ? '0' + number : number;
            }
            */
        },
        navigation: {
            nextEl: '.block-info__slider-button-next',
            prevEl: '.block-info__slider-button-prev',
        },
    });

};

export default { init };